import { render } from "./freeTaxSales.vue?vue&type=template&id=0ac74102&scoped=true"
import script from "./freeTaxSales.vue?vue&type=script&lang=js"
export * from "./freeTaxSales.vue?vue&type=script&lang=js"

import "./freeTaxSales.vue?vue&type=style&index=0&id=0ac74102&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\taxes-calculator\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac74102"]])

export default __exports__